/* eslint-disable */
import { GET_UPLOAD_TIME_TABLE_CSV_LIST, SET_UPLOAD_TIME_TABLE_CSV, SET_TIME_TABLE_CSV_LIST_PAGE_NO_COUNTER, GET_ACTIVE_EXAM_LIST_DETAILS, GET_TIME_TABLE_DETAILS_BY_EXAM, SET_EXAM_TYPE_FOR_TIME_TABLE, SET_LANGUAGE_DETAILS_FOR_TIME_TABLE, SET_UPLOAD_TIME_TABLE_CSV_RESPONSE, SET_ADMIT_CARD_TEMPLATE_DROPDOWN, SET_EXAM_TEMPLATE_LIST_FOR_IMPORT_ADMIT_CARD_CSV, SET_EXAM_CENTER_LIST, GET_UPDATE_EXAM_TIME_TABLE_DATA, GET_TIME_TABLE_DETAILS_BY_TEMPLATE_ID, GET_TIME_TABLE_LISTING, GET_DATA_EXAM_TEMPLATE} from "../../common/constants/ActionTypes";
const initialState = {
    getUploadTimeTableCsvList: [],
    uploadTimeTableCsvErrList: [],
    timeTableCsvListPageNoCounter: 0,
    getActiveExamListData: [],
    getTimeTableDetails: [],
    getExamType: [],
    getLanguageData: [],
    uploadTimeTableCsvErrResponse: [],
    getAdmitCardTemplateList: [],
    getExamTemplateListForImportAdmitCardCsv: [],
    getExamCenterList: [],
    getUpdateTimeTableData: [],
    getUpdateTimeTableDataByTempId: {},
};

export default function timeTableManagementReducer(state = initialState, action) {
    switch (action.type) {
        case SET_UPLOAD_TIME_TABLE_CSV:
            return {
                ...state,
                uploadTimeTableCsvErrList: action.payload
            };
        case SET_UPLOAD_TIME_TABLE_CSV_RESPONSE:
            return {
                ...state,
                uploadTimeTableCsvErrResponse: action.payload
            };
        case GET_UPLOAD_TIME_TABLE_CSV_LIST:
            return {
                ...state,
                getUploadTimeTableCsvList: action.payload
            };
        case SET_TIME_TABLE_CSV_LIST_PAGE_NO_COUNTER:
            return {
                ...state,
                timeTableCsvListPageNoCounter: action.payload
            }
        case GET_ACTIVE_EXAM_LIST_DETAILS:
            return {
                ...state,
                getActiveExamListData: action.payload
            }
        case GET_TIME_TABLE_DETAILS_BY_EXAM:
            return {
                ...state,
                getTimeTableDetails: action.payload
            }
        case SET_EXAM_TYPE_FOR_TIME_TABLE:
            return {
                ...state,
                getExamType: action.payload
            }
        case SET_LANGUAGE_DETAILS_FOR_TIME_TABLE:
            return {
                ...state,
                getLanguageData: action.payload
            }
        case SET_ADMIT_CARD_TEMPLATE_DROPDOWN:
            return {
                ...state,
                getAdmitCardTemplateList: action.payload
            }
        case SET_EXAM_TEMPLATE_LIST_FOR_IMPORT_ADMIT_CARD_CSV:
            return {
                ...state,
                getExamTemplateListForImportAdmitCardCsv: action.payload
            }
        case SET_EXAM_CENTER_LIST:
            return {
                ...state,
                getExamCenterList: action.payload
            }
        case GET_UPDATE_EXAM_TIME_TABLE_DATA:
            return {
                ...state,
                getUpdateTimeTableData: action.payload
            }
        case GET_TIME_TABLE_DETAILS_BY_TEMPLATE_ID:
            return {
                ...state,
                getUpdateTimeTableDataByTempId: action.payload
            }
            case GET_TIME_TABLE_LISTING:
                return{
                    ...state,
                    getTimeTableExams:action.payload
                }
                case GET_DATA_EXAM_TEMPLATE:
                    return{
                        ...state,
                        getdataExamTemplate:action.payload
                    }
        default:
            return state;
    }

}